import axios from "axios";
import { a2e, p2e } from "@utils";
import useJwt from "@src/auth/jwt/useJwt";
import { API_URL } from "..";
import { toast } from "react-toastify";
import { createRefresh } from "@features/auth";
import {logout} from "@features/auth";

const instance = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
    // "Access-Control-Allow-Origin": "*",
  },
});

const AxiosInterceptor = ({ children }) => {
  // const authStore =
  // useEffect(() => {
  //   const reqInterceptor = (config) => {
  //     const token = useJwt.getToken();
  //     console.log(token);
  //     if (token) {
  //       config.headers.authorization = `Bearer ${token}`;
  //     }
  //     if (config.headers["Content-Type"] !== "multipart/form-data") {
  //       config.data =
  //         config.data && JSON.parse(p2e(a2e(JSON.stringify(config.data))));
  //     }
  //     return config;
  //   };
  //   const reqErrorInterceptor = (req) => {
  //     return req;
  //   };
  //   const resInterceptor = (response) => {
  //     return response;
  //   };

  //   const errInterceptor = (error) => {
  //     if (error.response.status !== 200 && error.response.status !== 500) {
  //       //    toast.error(error.response.data.message)
  //     }
  //     return Promise.reject(error);
  //   };

  //   const interceptor = instance.interceptors.response.use(
  //     resInterceptor,
  //     errInterceptor
  //   );
  //   const reqinterceptor = instance.interceptors.request.use(
  //     reqInterceptor,
  //     reqErrorInterceptor
  //   );

  //   return () => {
  //     instance.interceptors.response.eject(interceptor);
  //     instance.interceptors.request.eject(reqinterceptor);
  //   };
  // }, []);

  return children;
};
const reqInterceptor = (config) => {
  const token = useJwt.getToken();

  if (token) {
    config.headers.authorization = `Bearer ${token}`;
  }
  if (config.data instanceof FormData) {
    // Preserve FormData contents
    const formDataEntries = {};
    config.data.forEach((value, key) => {
      formDataEntries[key] = value;
    });
    config._retryOriginalData = formDataEntries;
  } else if (config.headers["Content-Type"] !== "multipart/form-data") {
    config.data =
      config.data && JSON.parse(p2e(a2e(JSON.stringify(config.data))));
    if (!config._retryOriginalData) {
      config._retryOriginalData = config.data; // Preserve original data
    }
  }

  return config;
};
const reqErrorInterceptor = (req) => {
  return req;
};
const resInterceptor = (response) => {
  return response;
};

let isRefreshing = false; // Flag to check if token refresh is in progress
let failedQueue = []; // Queue to hold failed requests

const processQueue = (error, token = null) => {
  failedQueue.forEach((promise) => {
    if (error) {
      promise.reject(error);
    } else {
      promise.resolve(token);
    }
  });
  failedQueue = [];
};

const toastError = (errorObj) => {
  // Recursively log and toast error values
  Object.keys(errorObj).forEach((key) => {
    if (typeof errorObj[key] === "object" && errorObj[key] !== null) {
      toastError(errorObj[key]);
    } else {
      toast.error(errorObj[key]);
    }
  });
};

const errInterceptor = async (error) => {
  const originalRequest = error.config;

  // Restore FormData if it was used
  if (
    originalRequest._retryOriginalData &&
    originalRequest.headers["Content-Type"] === "multipart/form-data"
  ) {
    const formData = new FormData();
    Object.entries(originalRequest._retryOriginalData).forEach(
      ([key, value]) => {
        formData.append(key, value);
      }
    );
    originalRequest.data = formData;
  } else if (originalRequest._retryOriginalData) {
    originalRequest.data = originalRequest._retryOriginalData; // Restore non-FormData payload
  }

  if (
    error.response &&
    error.response.data.code === "token_not_valid" &&
    error.response.data.messages.some(
      (msg) =>
        msg.token_class === "AccessToken" &&
        msg.message === "Token is invalid or expired"
    )
  ) {
    if (!isRefreshing) {
      isRefreshing = true;
      const refreshToken = localStorage.getItem("refreshToken");

      try {
        const refreshResponse = await createRefresh({
          data: { refresh: refreshToken },
        });

        if (refreshResponse.status === 200) {
          const newAccessToken = refreshResponse.data.access;

          // Store new access token
          localStorage.setItem("accessToken", newAccessToken);
          useJwt.setToken(newAccessToken);

          // Process all failed requests in the queue
          processQueue(null, newAccessToken);
          isRefreshing = false;

          // Retry the original request with the new token
          originalRequest.headers.authorization = `Bearer ${newAccessToken}`;
          return instance(originalRequest);
        }
      } catch (refreshError) {
        // If refresh fails, reject all queued requests and redirect to sign-in
        processQueue(refreshError, null);
        isRefreshing = false;
        // await logout()
        localStorage.removeItem("userData");
        localStorage.removeItem("accessToken");
        localStorage.removeItem("refreshToken");
        window.location.href = "/signin";
        return Promise.reject(refreshError);
      }
    }

    // Queue the request and wait for the token to be refreshed
    return new Promise((resolve, reject) => {
      failedQueue.push({ resolve, reject });
    })
      .then((newToken) => {
        originalRequest.headers.authorization = `Bearer ${newToken}`;
        return instance(originalRequest); // Retrying the request
      })
      .catch((err) => {
        return Promise.reject(err);
      });
  }

  if ( error.response.status === 404 || error.response.status === 400 ) {
    toastError(error.response.data);

  }

  if (error.response.status === 403 || error.response.status === 401) {
    toastError(error.response.data);
    // await logout()

    localStorage.removeItem("userData");
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    if (window.location.pathname !== "/signin") {
      window.location.href = "/signin";
    }
  }

  return Promise.reject(error);
};
const interceptor = instance.interceptors.response.use(
  resInterceptor,
  errInterceptor
);

const reqinterceptor = instance.interceptors.request.use(
  reqInterceptor,
  reqErrorInterceptor
);
export { AxiosInterceptor };
export default instance;
